// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"532":"0da30c4868f80da13552","678":"fac636462d8532488cfe"}[chunkId] + ".js";
};